module.exports = __webpack_public_path__ + "img/check-white.df0e1126.svg";